module.exports = __webpack_public_path__ + "static/media/organizer_15.7a05a880.jpg";